import React, { createContext, useEffect, useState } from "react";
import { useAccount, useWalletClient, useNetwork } from "wagmi";

let initialState = {
  account: null,
  signer: null,
  chainIdArray: [],
  chainId: 0,
};

export const serverUrl =
  process.env.NODE_ENV === "production"
    ? "https://xratio-f902b56e950f.herokuapp.com"
    : "http://localhost:7000";

export const twitterPostLink = `https://twitter.com/intent/tweet?text=${encodeURIComponent(
  "#bitgrokai $BGAI"
)}`;
// export const serverUrl = "http://localhost:7000";

export const AppContext = createContext(initialState);
export const ConectivityProvider = ({ children }) => {
  const { address, isDisconnected } = useAccount();
  const { data: signer } = useWalletClient();
  const { chains, chain } = useNetwork();
  const chainIds = chains?.map((info) => info?.id);

  const [state, setState] = useState(initialState);
  const [userLoginStatus, setUserLoginStatus] = useState(false);
  const [userDatabaseId, setUserDatabaseId] = useState("");
  const [tweetHashTagsData, setTweetHashTagsData] = useState({
    orignalPost: 0,
    totalViews: 0,
    comments: 0,
    likes: 0,
    retweet: 0,
    quote: 0,
    postPoints: 0,
    viewsPoints: 0,
    commentsPoints: 0,
    likesPoints: 0,
    retweetPoints: 0,
    quotePoints: 0,
    claimPoints: 0,
  });

  useEffect(() => {
    setState({
      account: address ?? null,
      signer: signer ?? null,
    });
  }, [isDisconnected, address, signer]);
  return (
    <AppContext.Provider
      value={{
        account: state.account,
        signer: state.signer,
        chainIdArray: chainIds,
        chainId: chain?.id,
        userLoginStatus,
        setUserLoginStatus,
        userDatabaseId,
        setUserDatabaseId,
        tweetHashTagsData,
        setTweetHashTagsData,
      }}
    >
      {children}
    </AppContext.Provider>
  );
};
